//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: "Contrato de confidencialidad"
    },
    width: {
      type: Number,
      default: 800
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    custom_title: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  methods: {
    onClose: function onClose() {
      this.isOpen = false;
    },
    onReject: function onReject() {
      this.isOpen = false;
      this.$emit('onClose');
    },
    onOpen: function onOpen() {
      this.isOpen = true;
    },
    onAccept: function onAccept() {
      this.$emit('onAccept');
    }
  }
};